<template lang="html">
  <v-navigation-drawer v-model="menu" fixed temporary :permanent="permanent" :width="WindowsWidth">
    <v-container fluid class="pa-0 fill-height">
      <v-row class="ma-0 fill-height">
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0 fill-height">
          <div class="fill-height align-center">
            <v-btn class="ma-2 transparent" large color="teal" icon @click="CloseMenu">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-list v-if="!checkUser || checkUser.auth_by !== 'BASIC' && checkUser.auth_by !== 'GUEST'">
              <v-list-item @click="goTo('home')">
                <v-list-item-content>
                  <v-list-item-title>{{ $t('home') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="ma-auto" style="width: calc(100% - 25px);" />
              <template v-for="(item, idx) in guest" two-line>
                <v-list-item :key="idx + '-guest'" @click="goTo(item.link)">
                  <v-list-item-content>
                    <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider :key="idx + '-divider'" class="ma-auto" style="width: calc(100% - 25px);" />
              </template>
              <v-list-item class="__wa-chat" @click="goToWhatsApp()">
                <v-list-item-content>
                  <v-list-item-title>Chat WhatsApp</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="ma-auto" style="width: calc(100% - 25px);" />
            </v-list>
            <v-list v-else class="__list-user">
              <v-list-item three-line>
                <v-list-item-avatar size="65" class="elevation-1">
                  <v-img :src="user.photo_xs" />
                </v-list-item-avatar>
                <v-list-item-content class="__content-user">
                  <v-list-item-title>
                    {{ user.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="primary--text font-weight-bold cursor-pointer" @click="showProfile()">
                      {{ $t('edit_account') }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <div class="d-flex __container-list">
                <div class="__wrapper-profile mb-2">
                  <div class="__wrapper-profile-list">
                    <div class="d-flex col-profile" @click="goToLoyaltyPoint()">
                      <div class="d-flex align-center pa-1 flex-1-1">
                        <div class="profile-icon">
                          <img src="@/assets/images/svg/icon_loyalty_point.svg" alt="Transactions">
                        </div>
                        <div class="profile-content">
                          <span>
                            Loyalty points
                          </span>
                          <span>
                            {{ user.join_loyalty_points }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <v-list-item @click="goTo('home')">
                <v-list-item-content>
                  <v-list-item-title>{{ $t('home') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="ma-auto" style="width: calc(100% - 25px);" />
              <template v-for="(item, idx) in listNav">
                <v-list-item :key="idx + '-auth'" @click="goTo(item.link)">
                  <v-list-item-content>
                    <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider :key="idx + '-divider'" class="ma-auto" style="width: calc(100% - 25px);" />
              </template>
              <v-list-item class="__wa-chat" @click="goToWhatsApp()">
                <v-list-item-content>
                  <v-list-item-title>Chat WhatsApp</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="ma-auto" style="width: calc(100% - 25px);" />
              <v-list-item @click="showPopupLogout()">
                <v-list-item-content>
                  <v-list-item-title>{{ $t('logout') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <div class="px-4 py-2">
              <v-btn :ripple="false" text class="mr-3 text-none btn-locale" @click="dialog.dialogLocale = true">
                <v-img
                  :src="getImgUrl(locale)"
                  contain
                  height="22"
                  width="22"
                  max-width="22"
                />
                <span class="ml-2 mr-2">
                  {{ locale === 'id' ? 'Bahasa Indonesia' : 'English' }}
                </span>
                <v-icon right>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </div>
            <profile />
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialog.dialogLocale" max-width="290">
      <v-card>
        <v-card-title class="title font-weight-bold">
          {{ $t('select_language') }}
        </v-card-title>
        <v-card-text>
          <v-list>
            <template v-for="(item, index) in availableLocales">
              <v-list-item :key="item" @click="changeLocale(item)">
                <v-list-item-avatar size="30" tile>
                  <v-img :src="getImgUrl(item)" contain />
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>
                    {{ item === 'id' ? 'Bahasa Indonesia' : 'English' }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="index" />
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogLogout" max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $t('confirm') }}
        </v-card-title>
        <v-card-text>
          {{ $t('are_you_sure_to_logout') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="dialog.dialogLogout = false">
            {{ $t('no') }}
          </v-btn>
          <v-btn color="primary" outlined @click="logout()">
            {{ $t('yes') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
import {
  getData as getDataCustomer
} from '@/api/customer'
import {
  logout as logoutCustomer
} from '@/api/auth'
import { mapGetters } from 'vuex'
import { setLocale } from '@/utils/locale'
import profile from '@/components/modules/profile/Profile'
export default {
  components: {
    profile
  },
  data: () => ({
    dialog: {
      dialogLogout: false,
      dialogLocale: false
    },
    guest: [
      { id: 1, title: 'login', link: 'login' },
      { id: 1, title: 'your_order', link: 'orders' }
    ],
    listNav: [
      { id: 1, title: 'your_order', link: 'orders' },
      { id: 2, title: 'voucher', link: 'vouchers' },
      { id: 3, title: 'favorite', link: 'favorite' }
    ],
    user: {},
    menu: null,
    permanent: false,
    WindowsWidth: 256,
    setting: {
      AddShow: false,
      method: '',
      ShowPopup: false
    }
  }),
  computed: {
    ...mapGetters(['checkUser']),
    availableLocales() {
      return this.$i18n.availableLocales
    },
    locale() {
      return this.$i18n.locale
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    this.$root.$on('ShowMenu', (dataMenu) => {
      this.menu = dataMenu.show
      this.permanent = dataMenu.permanent
      this.fetchCustomer()
    })
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted() {
    this.$root.$on('ClosePopup', (dataMenu) => {
      this.setting.ShowPopup = dataMenu
    })
  },
  methods: {
    async fetchCustomer() {
      try {
        const { data } = await getDataCustomer()
        this.$store.state.loading_axios = false
        this.user = data.data
      } catch (e) {
        if (e.statusCode === 403) {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
          // this.$store.dispatch('remove_token')
        } else {
          return false
        }
      }
    },
    getImgUrl(img) {
      var images = require.context('@/assets/images/flags/', false, /\.png$/)
      return images('./' + img + '.png')
    },
    CloseMenu() {
      this.menu = false
      this.permanent = false
    },
    handleResize() {
      this.WindowsWidth = window.innerWidth
    },
    goTo(data) {
      this.CloseMenu()
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        this.$router.push({ name: data }).catch(() => {})
        // window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: data }).catch(() => {})
      }
    },
    goToLoyaltyPoint() {
      const dataProfile = {
        show: false,
        user: {}
      }
      this.$root.$emit('ShowProfile', dataProfile)
      const closeMenu = {
        show: false,
        permanent: false
      }
      this.$root.$emit('ShowMenu', closeMenu)
      this.$router.push({ name: 'loyalty_point' }).catch(() => {})
    },
    goToTansactions() {
      const dataProfile = {
        show: false,
        user: {}
      }
      this.$root.$emit('ShowProfile', dataProfile)
      const closeMenu = {
        show: false,
        permanent: false
      }
      this.$root.$emit('ShowMenu', closeMenu)
      this.$router.push({ name: 'transactions' }).catch(() => {})
    },
    showProfile() {
      const dataProfile = {
        show: true,
        user: this.user
      }
      this.$root.$emit('ShowProfile', dataProfile)
    },
    showPopupLogout() {
      const closeMenu = {
        show: false,
        permanent: false
      }
      this.$root.$emit('ShowMenu', closeMenu)
      this.dialog.dialogLogout = true
    },
    async logout() {
      try {
        await logoutCustomer()
        this.$store.state.loading_axios = false
        this.$store.dispatch('fetchToken')
        const astra_outlet = this.$store.state.store_astra
        const tmii_outlet = this.$store.state.store_tmii
        const url_id = this.$store.state.url_domain

        if (tmii_outlet.indexOf(url_id) !== -1) {
          window.location.href = 'https://order.kulinertmii.id'
        } else if (astra_outlet.indexOf(url_id) !== -1) {
          window.location.href = 'https://zestloungemenaraastra.myolsera.com'
        } else {
          this.$router.push({ name: 'home' }).catch(() => {})
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
      this.dialog.dialogLogout = false
    },
    goToWhatsApp() {
      if (!this.$isEmpty(this.$store.state.selected_store)) {
        let chatWA = null
        if (!this.$isEmpty(this.$store.state.selected_store.setting)) {
          chatWA = this.$store.state.selected_store.setting.whatsapp
        }
        if (chatWA) {
          window.open('http://wa.me/' + chatWA, '_blank')
        }
      }
    },
    changeLocale(locale) {
      this.$i18n.locale = locale
      setLocale(locale)
      this.dialog.dialogLocale = false
      this.$router.go()
    }
  }
}
</script>
